import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import NotificationTable from './NotificationTable'
// import UserAdd from './UserAdd'
// import UserEdit from './Edit'
// import UserView from './UserView'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import { useTranslation } from 'react-i18next'
import NotificationAdd from './NotificationAdd'
import ViewNotifications from './ViewNotifications'

function Notification() {
  const { t } = useTranslation()
  const { logoutUser, notification,user } = useContext(AuthContext)
  const manager = user?.permission?.find(e => e.manager === 'notification_managers') ?? {}
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [addShowModal, setShowModal] = useState(false)
  const [categoryAdd, setCategoryAdd] = useState(false)
  const [editShowModal, setEditShowModal] = useState(false)
  const [viewShowModal, setViewShowModal] = useState(false)
  const [notifications, setAllNotifications] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [isDelete, setIsDelete] = useState(false)
  const [filterData, setFilterData] = useState({ category: '', searchkey: '', startDate: '', endDate: '', isReset: false, isFilter: false })
  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })

  // get all notification function-
  const getAllNotifications = async (data) => {
    try {
      const { category, startDate, endDate, searchkey, isFilter } = filterData
      if ((data?.deletePage && !(notifications?.length > 1) || (isFilter && category && data?.statusChange && !(notifications?.length > 1)))) {
        if (!(notifications?.length > 1)) {
          setPage(page - 1)
          setIsDelete(true)
          setPaginationObj({ ...paginationObj, page: page - 1 })
        }
      }
      else {
        setIsDelete(false)
      }
      const payload = {
        page,
        pageSize,
        status: category,
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        keyword: searchkey,
        sortKey: sort.sortKey,
        sortType: sort.sortType
      }

      const path = apiPath.notifications
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        const resultStatus = result?.data?.success
        setAllNotifications(response?.docs)
        setPaginationObj({
          ...paginationObj,
          page: resultStatus ? response.page : null,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null
        })
      }
    } catch (error) {
      console.log('error ', error)
      setPaginationObj({})
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  const handleChangeData = (e) => {
    // setKeyword(e.target.value)
    setFilterData({ ...filterData, searchkey: e.target.value, isFilter: true })
    setPage(1)
  }


  const handlePageClick = (event) => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handelEdit = (item) => {
    setItem(item)
    setEditShowModal(true)
  }

  const handleUserView = (item) => {
    setItem(item)
    setViewShowModal(true)
  }
  const handleCategory = () => {
    setCategoryAdd(!categoryAdd)
  }
  useEffect(() => {
    getAllNotifications()
  }, [page, filterData, sort])

  const handleSearchKey = (e) => {
    setFilterData({ ...filterData, searchkey: e.target.value, isFilter: true })
    setPage(1)
  }

  const handleReset = () => {
    setFilterData({ category: '', searchkey: '', startDate: '', endDate: '', isReset: true, isFilter: false })
    setPage(1)
    setIsDelete(true)
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({ ...filterData, startDate: start, endDate: end, isFilter: true })
    setIsDelete(true)
  }
  const statusPage = (e) => {
    setFilterData({ ...filterData, category: e.target.value, isFilter: true })
    setPage(1)
    setIsDelete(true)
  }
  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              {/* <div className='col-span-2 flex flex-wrap  items-center'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap justify-center mb-2 2xl:mb-0'>
                  
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  
                  <button
                    type='button'
                    onClick={handleReset}
                    className='bg-LightBlue text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button>

                </div>
              </div> */}

              <div className='ml-auto lg:pt-0 pt-2'>
                {/* <label
                  htmlFor='default-search'
                  className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
                >
                  {t('O_SEARCH')}
                </label> */}
                <div className='flex justify-end'>
                  {/* <div className='relative '>
                    <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                      <svg
                        aria-hidden='true'
                        className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        {!filterData?.searchkey && (
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                          />
                        )}
                      </svg>
                    </div>
                    <input
                      type='search'
                      id='default-search'
                      title=''
                      className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder={t('SUB_ADMIN_SEARCH_BY_USER_NAME_EMAIL_MOBILE')}
                      value={filterData?.searchkey}
                      required
                      onChange={(e) => handleChangeData(e)}
                    />
                  </div> */}
                   {(manager?.add ||
                    user?.role==='admin') && (
                  <button
                    title={t('ADD_NOTIFICATION')}
                    type='button'
                    className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                    // onClick={() => setShowModal(true)}
                    onClick={() => handleCategory()}
                  >
                    + {t('ADD_NOTIFICATION')}
                  </button>)}

                </div>
              </div>
            </form>
            <NotificationTable
              notifications={notifications}
              notification={notification}
              getAllNotifications={getAllNotifications}
              handelEdit={handelEdit}
              handleUserView={handleUserView}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
            />

            {/* {addShowModal ? (
              <AddNotification setShowModal={setShowModal} getAllNotifications={getAllNotifications} />
            ) : null} */}

            {categoryAdd ? (
              <NotificationAdd
                categoryAdd={categoryAdd}
                getAllNotifications={getAllNotifications}
                handleCategory={handleCategory}
                // subcategoryList={subcategoryList}

              />
            ) : null}
            {/* {categoryAdd ? (
              <AddNotification
                categoryAdd={categoryAdd}
                getAllNotifications={getAllNotifications}
                handleCategory={handleCategory}
                // subcategoryList={subcategoryList}

              />
            ) : null} */}

            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}

      {viewShowModal ? (
        <ViewNotifications
          setViewShowModal={setViewShowModal}
          item={item}
        />
      ) : null}
          </div>
        </div>
      </div>
      <>

        {/* {editShowModal ? (
          <UserEdit
            setEditShowModal={setEditShowModal}
            getAllNotifications={getAllNotifications}
            item={item}
          />
        ) : null} */}
        {/* {viewShowModal ? (
          <UserView
            setViewShowModal={setViewShowModal}
            getAllNotifications={getAllNotifications}
            item={item}
          />
        ) : null} */}
      </>
    </div>
  )
}
export default Notification
